export { ViewGridAdd as default } from './ViewGridAdd';
